import { info } from '../../features/src/i18n/locales/info';

export function getLanguage(locale: string) {
  return info[locale]?.contentful ?? info.en.contentful;
}

export function getDisplayName(locale: string) {
  return info[locale]?.displayName ?? info.en.displayName;
}

export function getDisplayNameEn(locale: string) {
  return info[locale]?.displayNameEn ?? info.en.displayNameEn;
}
